import SvgActionAiFix from './components/display/Icon/compiled/ActionAiFix.es.js';
import SvgActionAiText from './components/display/Icon/compiled/ActionAiText.es.js';
import SvgActionAttachment from './components/display/Icon/compiled/ActionAttachment.es.js';
import SvgActionAutoRenew from './components/display/Icon/compiled/ActionAutoRenew.es.js';
import SvgActionBookmark from './components/display/Icon/compiled/ActionBookmark.es.js';
import SvgActionBookmarkFill from './components/display/Icon/compiled/ActionBookmarkFill.es.js';
import SvgActionBug from './components/display/Icon/compiled/ActionBug.es.js';
import SvgActionBugFill from './components/display/Icon/compiled/ActionBugFill.es.js';
import SvgActionBuild from './components/display/Icon/compiled/ActionBuild.es.js';
import SvgActionCalendar from './components/display/Icon/compiled/ActionCalendar.es.js';
import SvgActionCalendarFill from './components/display/Icon/compiled/ActionCalendarFill.es.js';
import SvgActionCamera from './components/display/Icon/compiled/ActionCamera.es.js';
import SvgActionCameraFill from './components/display/Icon/compiled/ActionCameraFill.es.js';
import SvgActionCheckConnection from './components/display/Icon/compiled/ActionCheckConnection.es.js';
import SvgActionCheckConnectionFill from './components/display/Icon/compiled/ActionCheckConnectionFill.es.js';
import SvgActionCompare from './components/display/Icon/compiled/ActionCompare.es.js';
import SvgActionCopy from './components/display/Icon/compiled/ActionCopy.es.js';
import SvgActionCopyFill from './components/display/Icon/compiled/ActionCopyFill.es.js';
import SvgActionDownload from './components/display/Icon/compiled/ActionDownload.es.js';
import SvgActionDrag from './components/display/Icon/compiled/ActionDrag.es.js';
import SvgActionEdit from './components/display/Icon/compiled/ActionEdit.es.js';
import SvgActionEditAi from './components/display/Icon/compiled/ActionEditAi.es.js';
import SvgActionEditAiFill from './components/display/Icon/compiled/ActionEditAiFill.es.js';
import SvgActionEditCircle from './components/display/Icon/compiled/ActionEditCircle.es.js';
import SvgActionEditCircleFill from './components/display/Icon/compiled/ActionEditCircleFill.es.js';
import SvgActionEditFill from './components/display/Icon/compiled/ActionEditFill.es.js';
import SvgActionEmail from './components/display/Icon/compiled/ActionEmail.es.js';
import SvgActionEmailFill from './components/display/Icon/compiled/ActionEmailFill.es.js';
import SvgActionExplore from './components/display/Icon/compiled/ActionExplore.es.js';
import SvgActionExploreFill from './components/display/Icon/compiled/ActionExploreFill.es.js';
import SvgActionFallback from './components/display/Icon/compiled/ActionFallback.es.js';
import SvgActionFilter from './components/display/Icon/compiled/ActionFilter.es.js';
import SvgActionFlag from './components/display/Icon/compiled/ActionFlag.es.js';
import SvgActionFlagFill from './components/display/Icon/compiled/ActionFlagFill.es.js';
import SvgActionFormula from './components/display/Icon/compiled/ActionFormula.es.js';
import SvgActionInsert from './components/display/Icon/compiled/ActionInsert.es.js';
import SvgActionLink from './components/display/Icon/compiled/ActionLink.es.js';
import SvgActionLock from './components/display/Icon/compiled/ActionLock.es.js';
import SvgActionLockFill from './components/display/Icon/compiled/ActionLockFill.es.js';
import SvgActionMoveToFolder from './components/display/Icon/compiled/ActionMoveToFolder.es.js';
import SvgActionMoveToFolderFill from './components/display/Icon/compiled/ActionMoveToFolderFill.es.js';
import SvgActionPhoto from './components/display/Icon/compiled/ActionPhoto.es.js';
import SvgActionPhotoFill from './components/display/Icon/compiled/ActionPhotoFill.es.js';
import SvgActionPin from './components/display/Icon/compiled/ActionPin.es.js';
import SvgActionPinFill from './components/display/Icon/compiled/ActionPinFill.es.js';
import SvgActionPlay from './components/display/Icon/compiled/ActionPlay.es.js';
import SvgActionPlayFill from './components/display/Icon/compiled/ActionPlayFill.es.js';
import SvgActionReadAloud from './components/display/Icon/compiled/ActionReadAloud.es.js';
import SvgActionReadAloudFill from './components/display/Icon/compiled/ActionReadAloudFill.es.js';
import SvgActionRename from './components/display/Icon/compiled/ActionRename.es.js';
import SvgActionRenameFill from './components/display/Icon/compiled/ActionRenameFill.es.js';
import SvgActionResend from './components/display/Icon/compiled/ActionResend.es.js';
import SvgActionResendFill from './components/display/Icon/compiled/ActionResendFill.es.js';
import SvgActionSend from './components/display/Icon/compiled/ActionSend.es.js';
import SvgActionSendFill from './components/display/Icon/compiled/ActionSendFill.es.js';
import SvgActionShare from './components/display/Icon/compiled/ActionShare.es.js';
import SvgActionShareFill from './components/display/Icon/compiled/ActionShareFill.es.js';
import SvgActionSwitchAccount from './components/display/Icon/compiled/ActionSwitchAccount.es.js';
import SvgActionSwitchAccountFill from './components/display/Icon/compiled/ActionSwitchAccountFill.es.js';
import SvgActionTrash from './components/display/Icon/compiled/ActionTrash.es.js';
import SvgActionTrashFill from './components/display/Icon/compiled/ActionTrashFill.es.js';
import SvgActionUpload from './components/display/Icon/compiled/ActionUpload.es.js';
import SvgActionZapDetails from './components/display/Icon/compiled/ActionZapDetails.es.js';
import SvgActionZapDetailsFill from './components/display/Icon/compiled/ActionZapDetailsFill.es.js';
import SvgAlertCircle from './components/display/Icon/compiled/AlertCircle.es.js';
import SvgAlertCircleColor from './components/display/Icon/compiled/AlertCircleColor.es.js';
import SvgAlertCircleFill from './components/display/Icon/compiled/AlertCircleFill.es.js';
import SvgAlertInfo from './components/display/Icon/compiled/AlertInfo.es.js';
import SvgAlertInfoFill from './components/display/Icon/compiled/AlertInfoFill.es.js';
import SvgAlertTriangle from './components/display/Icon/compiled/AlertTriangle.es.js';
import SvgAlertTriangleFill from './components/display/Icon/compiled/AlertTriangleFill.es.js';
import SvgArrowBigDown from './components/display/Icon/compiled/ArrowBigDown.es.js';
import SvgArrowBigLeft from './components/display/Icon/compiled/ArrowBigLeft.es.js';
import SvgArrowBigRight from './components/display/Icon/compiled/ArrowBigRight.es.js';
import SvgArrowBigUp from './components/display/Icon/compiled/ArrowBigUp.es.js';
import SvgArrowBranch from './components/display/Icon/compiled/ArrowBranch.es.js';
import SvgArrowCode from './components/display/Icon/compiled/ArrowCode.es.js';
import SvgArrowCodeDots from './components/display/Icon/compiled/ArrowCodeDots.es.js';
import SvgArrowConnect from './components/display/Icon/compiled/ArrowConnect.es.js';
import SvgArrowContract from './components/display/Icon/compiled/ArrowContract.es.js';
import SvgArrowDropdown from './components/display/Icon/compiled/ArrowDropdown.es.js';
import SvgArrowDropdownCircle from './components/display/Icon/compiled/ArrowDropdownCircle.es.js';
import SvgArrowExit from './components/display/Icon/compiled/ArrowExit.es.js';
import SvgArrowExpand from './components/display/Icon/compiled/ArrowExpand.es.js';
import SvgArrowLineLeft from './components/display/Icon/compiled/ArrowLineLeft.es.js';
import SvgArrowLineRight from './components/display/Icon/compiled/ArrowLineRight.es.js';
import SvgArrowOffsite from './components/display/Icon/compiled/ArrowOffsite.es.js';
import SvgArrowRedo from './components/display/Icon/compiled/ArrowRedo.es.js';
import SvgArrowRefresh from './components/display/Icon/compiled/ArrowRefresh.es.js';
import SvgArrowResizeDiagonalLeft from './components/display/Icon/compiled/ArrowResizeDiagonalLeft.es.js';
import SvgArrowResizeDiagonalRight from './components/display/Icon/compiled/ArrowResizeDiagonalRight.es.js';
import SvgArrowResizeHorizontal from './components/display/Icon/compiled/ArrowResizeHorizontal.es.js';
import SvgArrowSelect from './components/display/Icon/compiled/ArrowSelect.es.js';
import SvgArrowSmallDown from './components/display/Icon/compiled/ArrowSmallDown.es.js';
import SvgArrowSmallLeft from './components/display/Icon/compiled/ArrowSmallLeft.es.js';
import SvgArrowSmallRight from './components/display/Icon/compiled/ArrowSmallRight.es.js';
import SvgArrowSmallUp from './components/display/Icon/compiled/ArrowSmallUp.es.js';
import SvgArrowUndo from './components/display/Icon/compiled/ArrowUndo.es.js';
import SvgArrowZoom from './components/display/Icon/compiled/ArrowZoom.es.js';
import SvgCommentAdd from './components/display/Icon/compiled/CommentAdd.es.js';
import SvgCommentAddFill from './components/display/Icon/compiled/CommentAddFill.es.js';
import SvgCommentBlank from './components/display/Icon/compiled/CommentBlank.es.js';
import SvgCommentBlankFill from './components/display/Icon/compiled/CommentBlankFill.es.js';
import SvgCommentConvo from './components/display/Icon/compiled/CommentConvo.es.js';
import SvgCommentConvoFill from './components/display/Icon/compiled/CommentConvoFill.es.js';
import SvgCommentFilled from './components/display/Icon/compiled/CommentFilled.es.js';
import SvgCommentFilledFill from './components/display/Icon/compiled/CommentFilledFill.es.js';
import SvgCommentWaiting from './components/display/Icon/compiled/CommentWaiting.es.js';
import SvgCommentWaitingFill from './components/display/Icon/compiled/CommentWaitingFill.es.js';
import SvgFileAdd from './components/display/Icon/compiled/FileAdd.es.js';
import SvgFileAddFill from './components/display/Icon/compiled/FileAddFill.es.js';
import SvgFileFile from './components/display/Icon/compiled/FileFile.es.js';
import SvgFileFileFill from './components/display/Icon/compiled/FileFileFill.es.js';
import SvgFileFilled from './components/display/Icon/compiled/FileFilled.es.js';
import SvgFileFilledFill from './components/display/Icon/compiled/FileFilledFill.es.js';
import SvgFileGuide from './components/display/Icon/compiled/FileGuide.es.js';
import SvgFileGuideFill from './components/display/Icon/compiled/FileGuideFill.es.js';
import SvgFileRemove from './components/display/Icon/compiled/FileRemove.es.js';
import SvgFileRemoveFill from './components/display/Icon/compiled/FileRemoveFill.es.js';
import SvgFormAdd from './components/display/Icon/compiled/FormAdd.es.js';
import SvgFormAddCircle from './components/display/Icon/compiled/FormAddCircle.es.js';
import SvgFormAddCircleOutlined from './components/display/Icon/compiled/FormAddCircleOutlined.es.js';
import SvgFormAddSquare from './components/display/Icon/compiled/FormAddSquare.es.js';
import SvgFormAddSquareOutlined from './components/display/Icon/compiled/FormAddSquareOutlined.es.js';
import SvgFormBlank from './components/display/Icon/compiled/FormBlank.es.js';
import SvgFormCheck from './components/display/Icon/compiled/FormCheck.es.js';
import SvgFormCheckCircle from './components/display/Icon/compiled/FormCheckCircle.es.js';
import SvgFormCheckCircleOutlined from './components/display/Icon/compiled/FormCheckCircleOutlined.es.js';
import SvgFormCheckSquare from './components/display/Icon/compiled/FormCheckSquare.es.js';
import SvgFormCheckSquareOutlined from './components/display/Icon/compiled/FormCheckSquareOutlined.es.js';
import SvgFormDash from './components/display/Icon/compiled/FormDash.es.js';
import SvgFormDashCircle from './components/display/Icon/compiled/FormDashCircle.es.js';
import SvgFormDashCircleOutlined from './components/display/Icon/compiled/FormDashCircleOutlined.es.js';
import SvgFormDashSquare from './components/display/Icon/compiled/FormDashSquare.es.js';
import SvgFormDashSquareOutlined from './components/display/Icon/compiled/FormDashSquareOutlined.es.js';
import SvgFormRadioCheck from './components/display/Icon/compiled/FormRadioCheck.es.js';
import SvgFormRadioDot from './components/display/Icon/compiled/FormRadioDot.es.js';
import SvgFormRadioUnchecked from './components/display/Icon/compiled/FormRadioUnchecked.es.js';
import SvgFormText from './components/display/Icon/compiled/FormText.es.js';
import SvgFormTextAlignCenter from './components/display/Icon/compiled/FormTextAlignCenter.es.js';
import SvgFormTextAlignLeft from './components/display/Icon/compiled/FormTextAlignLeft.es.js';
import SvgFormTextAlignRight from './components/display/Icon/compiled/FormTextAlignRight.es.js';
import SvgFormTextLong from './components/display/Icon/compiled/FormTextLong.es.js';
import SvgFormToggle from './components/display/Icon/compiled/FormToggle.es.js';
import SvgFormX from './components/display/Icon/compiled/FormX.es.js';
import SvgFormXCircle from './components/display/Icon/compiled/FormXCircle.es.js';
import SvgFormXCircleOutlined from './components/display/Icon/compiled/FormXCircleOutlined.es.js';
import SvgMiscAi from './components/display/Icon/compiled/MiscAi.es.js';
import SvgMiscAiFill from './components/display/Icon/compiled/MiscAiFill.es.js';
import SvgMiscAt from './components/display/Icon/compiled/MiscAt.es.js';
import SvgMiscBolt from './components/display/Icon/compiled/MiscBolt.es.js';
import SvgMiscBoltAlt from './components/display/Icon/compiled/MiscBoltAlt.es.js';
import SvgMiscBoltAltFill from './components/display/Icon/compiled/MiscBoltAltFill.es.js';
import SvgMiscBoltFill from './components/display/Icon/compiled/MiscBoltFill.es.js';
import SvgMiscBoltOutlined from './components/display/Icon/compiled/MiscBoltOutlined.es.js';
import SvgMiscBundle from './components/display/Icon/compiled/MiscBundle.es.js';
import SvgMiscCheckpoint from './components/display/Icon/compiled/MiscCheckpoint.es.js';
import SvgMiscClock from './components/display/Icon/compiled/MiscClock.es.js';
import SvgMiscClockFill from './components/display/Icon/compiled/MiscClockFill.es.js';
import SvgMiscClockPlay from './components/display/Icon/compiled/MiscClockPlay.es.js';
import SvgMiscCloud from './components/display/Icon/compiled/MiscCloud.es.js';
import SvgMiscCloudCheck from './components/display/Icon/compiled/MiscCloudCheck.es.js';
import SvgMiscCloudCheckFill from './components/display/Icon/compiled/MiscCloudCheckFill.es.js';
import SvgMiscCloudFill from './components/display/Icon/compiled/MiscCloudFill.es.js';
import SvgMiscColor from './components/display/Icon/compiled/MiscColor.es.js';
import SvgMiscColorFill from './components/display/Icon/compiled/MiscColorFill.es.js';
import SvgMiscCookie from './components/display/Icon/compiled/MiscCookie.es.js';
import SvgMiscCookieFill from './components/display/Icon/compiled/MiscCookieFill.es.js';
import SvgMiscCopilot from './components/display/Icon/compiled/MiscCopilot.es.js';
import SvgMiscCreditCard from './components/display/Icon/compiled/MiscCreditCard.es.js';
import SvgMiscCreditCardFill from './components/display/Icon/compiled/MiscCreditCardFill.es.js';
import SvgMiscDollar from './components/display/Icon/compiled/MiscDollar.es.js';
import SvgMiscErrorHandler from './components/display/Icon/compiled/MiscErrorHandler.es.js';
import SvgMiscEvergreenAi from './components/display/Icon/compiled/MiscEvergreenAi.es.js';
import SvgMiscEye from './components/display/Icon/compiled/MiscEye.es.js';
import SvgMiscEyeClosed from './components/display/Icon/compiled/MiscEyeClosed.es.js';
import SvgMiscEyeFill from './components/display/Icon/compiled/MiscEyeFill.es.js';
import SvgMiscFingerprint from './components/display/Icon/compiled/MiscFingerprint.es.js';
import SvgMiscFire from './components/display/Icon/compiled/MiscFire.es.js';
import SvgMiscFireFill from './components/display/Icon/compiled/MiscFireFill.es.js';
import SvgMiscGraph from './components/display/Icon/compiled/MiscGraph.es.js';
import SvgMiscGraphBox from './components/display/Icon/compiled/MiscGraphBox.es.js';
import SvgMiscGraphBoxFill from './components/display/Icon/compiled/MiscGraphBoxFill.es.js';
import SvgMiscHand from './components/display/Icon/compiled/MiscHand.es.js';
import SvgMiscHandFill from './components/display/Icon/compiled/MiscHandFill.es.js';
import SvgMiscHeadset from './components/display/Icon/compiled/MiscHeadset.es.js';
import SvgMiscHeadsetFill from './components/display/Icon/compiled/MiscHeadsetFill.es.js';
import SvgMiscIdea from './components/display/Icon/compiled/MiscIdea.es.js';
import SvgMiscLearn from './components/display/Icon/compiled/MiscLearn.es.js';
import SvgMiscLearnFill from './components/display/Icon/compiled/MiscLearnFill.es.js';
import SvgMiscList from './components/display/Icon/compiled/MiscList.es.js';
import SvgMiscMcp from './components/display/Icon/compiled/MiscMcp.es.js';
import SvgMiscMic from './components/display/Icon/compiled/MiscMic.es.js';
import SvgMiscMicFill from './components/display/Icon/compiled/MiscMicFill.es.js';
import SvgMiscPackage from './components/display/Icon/compiled/MiscPackage.es.js';
import SvgMiscPie from './components/display/Icon/compiled/MiscPie.es.js';
import SvgMiscPieFill from './components/display/Icon/compiled/MiscPieFill.es.js';
import SvgMiscPin from './components/display/Icon/compiled/MiscPin.es.js';
import SvgMiscPinFill from './components/display/Icon/compiled/MiscPinFill.es.js';
import SvgMiscSecurity from './components/display/Icon/compiled/MiscSecurity.es.js';
import SvgMiscSecurityFill from './components/display/Icon/compiled/MiscSecurityFill.es.js';
import SvgMiscSteps from './components/display/Icon/compiled/MiscSteps.es.js';
import SvgMiscSteps1 from './components/display/Icon/compiled/MiscSteps1.es.js';
import SvgMiscSteps2 from './components/display/Icon/compiled/MiscSteps2.es.js';
import SvgMiscSteps3 from './components/display/Icon/compiled/MiscSteps3.es.js';
import SvgMiscStepsAlt from './components/display/Icon/compiled/MiscStepsAlt.es.js';
import SvgMiscStepsFill from './components/display/Icon/compiled/MiscStepsFill.es.js';
import SvgMiscTimelapse from './components/display/Icon/compiled/MiscTimelapse.es.js';
import SvgMiscTrigger from './components/display/Icon/compiled/MiscTrigger.es.js';
import SvgMiscUptime from './components/display/Icon/compiled/MiscUptime.es.js';
import SvgMiscUptimeFill from './components/display/Icon/compiled/MiscUptimeFill.es.js';
import SvgMiscWallet from './components/display/Icon/compiled/MiscWallet.es.js';
import SvgMiscWalletFill from './components/display/Icon/compiled/MiscWalletFill.es.js';
import SvgMiscWorld from './components/display/Icon/compiled/MiscWorld.es.js';
import SvgMiscWorldFill from './components/display/Icon/compiled/MiscWorldFill.es.js';
import SvgNavAiChatbot from './components/display/Icon/compiled/NavAiChatbot.es.js';
import SvgNavApps from './components/display/Icon/compiled/NavApps.es.js';
import SvgNavAppsFill from './components/display/Icon/compiled/NavAppsFill.es.js';
import SvgNavBell from './components/display/Icon/compiled/NavBell.es.js';
import SvgNavBellFill from './components/display/Icon/compiled/NavBellFill.es.js';
import SvgNavBlog from './components/display/Icon/compiled/NavBlog.es.js';
import SvgNavBlogFill from './components/display/Icon/compiled/NavBlogFill.es.js';
import SvgNavBriefcase from './components/display/Icon/compiled/NavBriefcase.es.js';
import SvgNavBriefcaseFill from './components/display/Icon/compiled/NavBriefcaseFill.es.js';
import SvgNavCanvas from './components/display/Icon/compiled/NavCanvas.es.js';
import SvgNavCentral from './components/display/Icon/compiled/NavCentral.es.js';
import SvgNavCog from './components/display/Icon/compiled/NavCog.es.js';
import SvgNavCogFill from './components/display/Icon/compiled/NavCogFill.es.js';
import SvgNavConnectedAssets from './components/display/Icon/compiled/NavConnectedAssets.es.js';
import SvgNavConnectedAssetsFill from './components/display/Icon/compiled/NavConnectedAssetsFill.es.js';
import SvgNavCustomAction from './components/display/Icon/compiled/NavCustomAction.es.js';
import SvgNavDashboard from './components/display/Icon/compiled/NavDashboard.es.js';
import SvgNavDashboardFill from './components/display/Icon/compiled/NavDashboardFill.es.js';
import SvgNavExplore from './components/display/Icon/compiled/NavExplore.es.js';
import SvgNavExploreFill from './components/display/Icon/compiled/NavExploreFill.es.js';
import SvgNavFolder from './components/display/Icon/compiled/NavFolder.es.js';
import SvgNavFolderFill from './components/display/Icon/compiled/NavFolderFill.es.js';
import SvgNavFunctions from './components/display/Icon/compiled/NavFunctions.es.js';
import SvgNavGridView from './components/display/Icon/compiled/NavGridView.es.js';
import SvgNavHelp from './components/display/Icon/compiled/NavHelp.es.js';
import SvgNavHelpFill from './components/display/Icon/compiled/NavHelpFill.es.js';
import SvgNavHome from './components/display/Icon/compiled/NavHome.es.js';
import SvgNavHomeFill from './components/display/Icon/compiled/NavHomeFill.es.js';
import SvgNavIntegrations from './components/display/Icon/compiled/NavIntegrations.es.js';
import SvgNavIntegrationsFill from './components/display/Icon/compiled/NavIntegrationsFill.es.js';
import SvgNavInterfaces from './components/display/Icon/compiled/NavInterfaces.es.js';
import SvgNavMcp from './components/display/Icon/compiled/NavMcp.es.js';
import SvgNavMenu from './components/display/Icon/compiled/NavMenu.es.js';
import SvgNavMenuAlt from './components/display/Icon/compiled/NavMenuAlt.es.js';
import SvgNavMoreHoriz from './components/display/Icon/compiled/NavMoreHoriz.es.js';
import SvgNavMoreVert from './components/display/Icon/compiled/NavMoreVert.es.js';
import SvgNavProductHub from './components/display/Icon/compiled/NavProductHub.es.js';
import SvgNavProjects from './components/display/Icon/compiled/NavProjects.es.js';
import SvgNavProjectsFill from './components/display/Icon/compiled/NavProjectsFill.es.js';
import SvgNavSearch from './components/display/Icon/compiled/NavSearch.es.js';
import SvgNavSearchFill from './components/display/Icon/compiled/NavSearchFill.es.js';
import SvgNavTable from './components/display/Icon/compiled/NavTable.es.js';
import SvgNavTableFill from './components/display/Icon/compiled/NavTableFill.es.js';
import SvgNavTables from './components/display/Icon/compiled/NavTables.es.js';
import SvgNavVersions from './components/display/Icon/compiled/NavVersions.es.js';
import SvgNavVersionsFill from './components/display/Icon/compiled/NavVersionsFill.es.js';
import SvgPartnerDashboard from './components/display/Icon/compiled/PartnerDashboard.es.js';
import SvgPartnerEmbed from './components/display/Icon/compiled/PartnerEmbed.es.js';
import SvgPersonAdd from './components/display/Icon/compiled/PersonAdd.es.js';
import SvgPersonAddFill from './components/display/Icon/compiled/PersonAddFill.es.js';
import SvgPersonCircle from './components/display/Icon/compiled/PersonCircle.es.js';
import SvgPersonCircleFill from './components/display/Icon/compiled/PersonCircleFill.es.js';
import SvgPersonGroup from './components/display/Icon/compiled/PersonGroup.es.js';
import SvgPersonGroupFill from './components/display/Icon/compiled/PersonGroupFill.es.js';
import SvgPersonOne from './components/display/Icon/compiled/PersonOne.es.js';
import SvgPersonOneFill from './components/display/Icon/compiled/PersonOneFill.es.js';
import SvgPersonSettings from './components/display/Icon/compiled/PersonSettings.es.js';
import SvgRatingCool from './components/display/Icon/compiled/RatingCool.es.js';
import SvgRatingHappy from './components/display/Icon/compiled/RatingHappy.es.js';
import SvgRatingHappyAlt from './components/display/Icon/compiled/RatingHappyAlt.es.js';
import SvgRatingHeart from './components/display/Icon/compiled/RatingHeart.es.js';
import SvgRatingHeartFill from './components/display/Icon/compiled/RatingHeartFill.es.js';
import SvgRatingNeutral from './components/display/Icon/compiled/RatingNeutral.es.js';
import SvgRatingNeutralAlt from './components/display/Icon/compiled/RatingNeutralAlt.es.js';
import SvgRatingSad from './components/display/Icon/compiled/RatingSad.es.js';
import SvgRatingSadAlt from './components/display/Icon/compiled/RatingSadAlt.es.js';
import SvgRatingStar from './components/display/Icon/compiled/RatingStar.es.js';
import SvgRatingStarFill from './components/display/Icon/compiled/RatingStarFill.es.js';
import SvgRatingThumbsBoth from './components/display/Icon/compiled/RatingThumbsBoth.es.js';
import SvgRatingThumbsBothFill from './components/display/Icon/compiled/RatingThumbsBothFill.es.js';
import SvgRatingThumbsDown from './components/display/Icon/compiled/RatingThumbsDown.es.js';
import SvgRatingThumbsDownFill from './components/display/Icon/compiled/RatingThumbsDownFill.es.js';
import SvgRatingThumbsUp from './components/display/Icon/compiled/RatingThumbsUp.es.js';
import SvgRatingThumbsUpFill from './components/display/Icon/compiled/RatingThumbsUpFill.es.js';
import SvgRatingVeryHappy from './components/display/Icon/compiled/RatingVeryHappy.es.js';
import SvgRatingVeryHappyAlt from './components/display/Icon/compiled/RatingVeryHappyAlt.es.js';
import SvgRatingVerySad from './components/display/Icon/compiled/RatingVerySad.es.js';
import SvgRatingVerySadAlt from './components/display/Icon/compiled/RatingVerySadAlt.es.js';
import SvgRatingWink from './components/display/Icon/compiled/RatingWink.es.js';
import SvgRatingWinkAlt from './components/display/Icon/compiled/RatingWinkAlt.es.js';
import SvgStatusAppApproval from './components/display/Icon/compiled/StatusAppApproval.es.js';
import SvgStatusFilter from './components/display/Icon/compiled/StatusFilter.es.js';
import SvgStatusFilterFill from './components/display/Icon/compiled/StatusFilterFill.es.js';
import SvgStatusPaused from './components/display/Icon/compiled/StatusPaused.es.js';
import SvgStatusPlaying from './components/display/Icon/compiled/StatusPlaying.es.js';
import SvgStatusPlayingFill from './components/display/Icon/compiled/StatusPlayingFill.es.js';
import SvgStatusStatus from './components/display/Icon/compiled/StatusStatus.es.js';
import SvgStatusStatusFill from './components/display/Icon/compiled/StatusStatusFill.es.js';
import SvgStatusStop from './components/display/Icon/compiled/StatusStop.es.js';
import SvgStatusStopFill from './components/display/Icon/compiled/StatusStopFill.es.js';
import SvgTeam from './components/display/Icon/compiled/Team.es.js';
import SvgTeamFill from './components/display/Icon/compiled/TeamFill.es.js';
import SvgZapierLogo from './components/display/Icon/compiled/ZapierLogo.es.js';

const Icons = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	ActionAiFix: SvgActionAiFix,
	ActionAiText: SvgActionAiText,
	ActionAttachment: SvgActionAttachment,
	ActionAutoRenew: SvgActionAutoRenew,
	ActionBookmark: SvgActionBookmark,
	ActionBookmarkFill: SvgActionBookmarkFill,
	ActionBug: SvgActionBug,
	ActionBugFill: SvgActionBugFill,
	ActionBuild: SvgActionBuild,
	ActionCalendar: SvgActionCalendar,
	ActionCalendarFill: SvgActionCalendarFill,
	ActionCamera: SvgActionCamera,
	ActionCameraFill: SvgActionCameraFill,
	ActionCheckConnection: SvgActionCheckConnection,
	ActionCheckConnectionFill: SvgActionCheckConnectionFill,
	ActionCompare: SvgActionCompare,
	ActionCopy: SvgActionCopy,
	ActionCopyFill: SvgActionCopyFill,
	ActionDownload: SvgActionDownload,
	ActionDrag: SvgActionDrag,
	ActionEdit: SvgActionEdit,
	ActionEditAi: SvgActionEditAi,
	ActionEditAiFill: SvgActionEditAiFill,
	ActionEditCircle: SvgActionEditCircle,
	ActionEditCircleFill: SvgActionEditCircleFill,
	ActionEditFill: SvgActionEditFill,
	ActionEmail: SvgActionEmail,
	ActionEmailFill: SvgActionEmailFill,
	ActionExplore: SvgActionExplore,
	ActionExploreFill: SvgActionExploreFill,
	ActionFallback: SvgActionFallback,
	ActionFilter: SvgActionFilter,
	ActionFlag: SvgActionFlag,
	ActionFlagFill: SvgActionFlagFill,
	ActionFormula: SvgActionFormula,
	ActionInsert: SvgActionInsert,
	ActionLink: SvgActionLink,
	ActionLock: SvgActionLock,
	ActionLockFill: SvgActionLockFill,
	ActionMoveToFolder: SvgActionMoveToFolder,
	ActionMoveToFolderFill: SvgActionMoveToFolderFill,
	ActionPhoto: SvgActionPhoto,
	ActionPhotoFill: SvgActionPhotoFill,
	ActionPin: SvgActionPin,
	ActionPinFill: SvgActionPinFill,
	ActionPlay: SvgActionPlay,
	ActionPlayFill: SvgActionPlayFill,
	ActionReadAloud: SvgActionReadAloud,
	ActionReadAloudFill: SvgActionReadAloudFill,
	ActionRename: SvgActionRename,
	ActionRenameFill: SvgActionRenameFill,
	ActionResend: SvgActionResend,
	ActionResendFill: SvgActionResendFill,
	ActionSend: SvgActionSend,
	ActionSendFill: SvgActionSendFill,
	ActionShare: SvgActionShare,
	ActionShareFill: SvgActionShareFill,
	ActionSwitchAccount: SvgActionSwitchAccount,
	ActionSwitchAccountFill: SvgActionSwitchAccountFill,
	ActionTrash: SvgActionTrash,
	ActionTrashFill: SvgActionTrashFill,
	ActionUpload: SvgActionUpload,
	ActionZapDetails: SvgActionZapDetails,
	ActionZapDetailsFill: SvgActionZapDetailsFill,
	AlertCircle: SvgAlertCircle,
	AlertCircleColor: SvgAlertCircleColor,
	AlertCircleFill: SvgAlertCircleFill,
	AlertInfo: SvgAlertInfo,
	AlertInfoFill: SvgAlertInfoFill,
	AlertTriangle: SvgAlertTriangle,
	AlertTriangleFill: SvgAlertTriangleFill,
	ArrowBigDown: SvgArrowBigDown,
	ArrowBigLeft: SvgArrowBigLeft,
	ArrowBigRight: SvgArrowBigRight,
	ArrowBigUp: SvgArrowBigUp,
	ArrowBranch: SvgArrowBranch,
	ArrowCode: SvgArrowCode,
	ArrowCodeDots: SvgArrowCodeDots,
	ArrowConnect: SvgArrowConnect,
	ArrowContract: SvgArrowContract,
	ArrowDropdown: SvgArrowDropdown,
	ArrowDropdownCircle: SvgArrowDropdownCircle,
	ArrowExit: SvgArrowExit,
	ArrowExpand: SvgArrowExpand,
	ArrowLineLeft: SvgArrowLineLeft,
	ArrowLineRight: SvgArrowLineRight,
	ArrowOffsite: SvgArrowOffsite,
	ArrowRedo: SvgArrowRedo,
	ArrowRefresh: SvgArrowRefresh,
	ArrowResizeDiagonalLeft: SvgArrowResizeDiagonalLeft,
	ArrowResizeDiagonalRight: SvgArrowResizeDiagonalRight,
	ArrowResizeHorizontal: SvgArrowResizeHorizontal,
	ArrowSelect: SvgArrowSelect,
	ArrowSmallDown: SvgArrowSmallDown,
	ArrowSmallLeft: SvgArrowSmallLeft,
	ArrowSmallRight: SvgArrowSmallRight,
	ArrowSmallUp: SvgArrowSmallUp,
	ArrowUndo: SvgArrowUndo,
	ArrowZoom: SvgArrowZoom,
	CommentAdd: SvgCommentAdd,
	CommentAddFill: SvgCommentAddFill,
	CommentBlank: SvgCommentBlank,
	CommentBlankFill: SvgCommentBlankFill,
	CommentConvo: SvgCommentConvo,
	CommentConvoFill: SvgCommentConvoFill,
	CommentFilled: SvgCommentFilled,
	CommentFilledFill: SvgCommentFilledFill,
	CommentWaiting: SvgCommentWaiting,
	CommentWaitingFill: SvgCommentWaitingFill,
	FileAdd: SvgFileAdd,
	FileAddFill: SvgFileAddFill,
	FileFile: SvgFileFile,
	FileFileFill: SvgFileFileFill,
	FileFilled: SvgFileFilled,
	FileFilledFill: SvgFileFilledFill,
	FileGuide: SvgFileGuide,
	FileGuideFill: SvgFileGuideFill,
	FileRemove: SvgFileRemove,
	FileRemoveFill: SvgFileRemoveFill,
	FormAdd: SvgFormAdd,
	FormAddCircle: SvgFormAddCircle,
	FormAddCircleOutlined: SvgFormAddCircleOutlined,
	FormAddSquare: SvgFormAddSquare,
	FormAddSquareOutlined: SvgFormAddSquareOutlined,
	FormBlank: SvgFormBlank,
	FormCheck: SvgFormCheck,
	FormCheckCircle: SvgFormCheckCircle,
	FormCheckCircleOutlined: SvgFormCheckCircleOutlined,
	FormCheckSquare: SvgFormCheckSquare,
	FormCheckSquareOutlined: SvgFormCheckSquareOutlined,
	FormDash: SvgFormDash,
	FormDashCircle: SvgFormDashCircle,
	FormDashCircleOutlined: SvgFormDashCircleOutlined,
	FormDashSquare: SvgFormDashSquare,
	FormDashSquareOutlined: SvgFormDashSquareOutlined,
	FormRadioCheck: SvgFormRadioCheck,
	FormRadioDot: SvgFormRadioDot,
	FormRadioUnchecked: SvgFormRadioUnchecked,
	FormText: SvgFormText,
	FormTextAlignCenter: SvgFormTextAlignCenter,
	FormTextAlignLeft: SvgFormTextAlignLeft,
	FormTextAlignRight: SvgFormTextAlignRight,
	FormTextLong: SvgFormTextLong,
	FormToggle: SvgFormToggle,
	FormX: SvgFormX,
	FormXCircle: SvgFormXCircle,
	FormXCircleOutlined: SvgFormXCircleOutlined,
	MiscAi: SvgMiscAi,
	MiscAiFill: SvgMiscAiFill,
	MiscAt: SvgMiscAt,
	MiscBolt: SvgMiscBolt,
	MiscBoltAlt: SvgMiscBoltAlt,
	MiscBoltAltFill: SvgMiscBoltAltFill,
	MiscBoltFill: SvgMiscBoltFill,
	MiscBoltOutlined: SvgMiscBoltOutlined,
	MiscBundle: SvgMiscBundle,
	MiscCheckpoint: SvgMiscCheckpoint,
	MiscClock: SvgMiscClock,
	MiscClockFill: SvgMiscClockFill,
	MiscClockPlay: SvgMiscClockPlay,
	MiscCloud: SvgMiscCloud,
	MiscCloudCheck: SvgMiscCloudCheck,
	MiscCloudCheckFill: SvgMiscCloudCheckFill,
	MiscCloudFill: SvgMiscCloudFill,
	MiscColor: SvgMiscColor,
	MiscColorFill: SvgMiscColorFill,
	MiscCookie: SvgMiscCookie,
	MiscCookieFill: SvgMiscCookieFill,
	MiscCopilot: SvgMiscCopilot,
	MiscCreditCard: SvgMiscCreditCard,
	MiscCreditCardFill: SvgMiscCreditCardFill,
	MiscDollar: SvgMiscDollar,
	MiscErrorHandler: SvgMiscErrorHandler,
	MiscEvergreenAi: SvgMiscEvergreenAi,
	MiscEye: SvgMiscEye,
	MiscEyeClosed: SvgMiscEyeClosed,
	MiscEyeFill: SvgMiscEyeFill,
	MiscFingerprint: SvgMiscFingerprint,
	MiscFire: SvgMiscFire,
	MiscFireFill: SvgMiscFireFill,
	MiscGraph: SvgMiscGraph,
	MiscGraphBox: SvgMiscGraphBox,
	MiscGraphBoxFill: SvgMiscGraphBoxFill,
	MiscHand: SvgMiscHand,
	MiscHandFill: SvgMiscHandFill,
	MiscHeadset: SvgMiscHeadset,
	MiscHeadsetFill: SvgMiscHeadsetFill,
	MiscIdea: SvgMiscIdea,
	MiscLearn: SvgMiscLearn,
	MiscLearnFill: SvgMiscLearnFill,
	MiscList: SvgMiscList,
	MiscMcp: SvgMiscMcp,
	MiscMic: SvgMiscMic,
	MiscMicFill: SvgMiscMicFill,
	MiscPackage: SvgMiscPackage,
	MiscPie: SvgMiscPie,
	MiscPieFill: SvgMiscPieFill,
	MiscPin: SvgMiscPin,
	MiscPinFill: SvgMiscPinFill,
	MiscSecurity: SvgMiscSecurity,
	MiscSecurityFill: SvgMiscSecurityFill,
	MiscSteps: SvgMiscSteps,
	MiscSteps1: SvgMiscSteps1,
	MiscSteps2: SvgMiscSteps2,
	MiscSteps3: SvgMiscSteps3,
	MiscStepsAlt: SvgMiscStepsAlt,
	MiscStepsFill: SvgMiscStepsFill,
	MiscTimelapse: SvgMiscTimelapse,
	MiscTrigger: SvgMiscTrigger,
	MiscUptime: SvgMiscUptime,
	MiscUptimeFill: SvgMiscUptimeFill,
	MiscWallet: SvgMiscWallet,
	MiscWalletFill: SvgMiscWalletFill,
	MiscWorld: SvgMiscWorld,
	MiscWorldFill: SvgMiscWorldFill,
	NavAiChatbot: SvgNavAiChatbot,
	NavApps: SvgNavApps,
	NavAppsFill: SvgNavAppsFill,
	NavBell: SvgNavBell,
	NavBellFill: SvgNavBellFill,
	NavBlog: SvgNavBlog,
	NavBlogFill: SvgNavBlogFill,
	NavBriefcase: SvgNavBriefcase,
	NavBriefcaseFill: SvgNavBriefcaseFill,
	NavCanvas: SvgNavCanvas,
	NavCentral: SvgNavCentral,
	NavCog: SvgNavCog,
	NavCogFill: SvgNavCogFill,
	NavConnectedAssets: SvgNavConnectedAssets,
	NavConnectedAssetsFill: SvgNavConnectedAssetsFill,
	NavCustomAction: SvgNavCustomAction,
	NavDashboard: SvgNavDashboard,
	NavDashboardFill: SvgNavDashboardFill,
	NavExplore: SvgNavExplore,
	NavExploreFill: SvgNavExploreFill,
	NavFolder: SvgNavFolder,
	NavFolderFill: SvgNavFolderFill,
	NavFunctions: SvgNavFunctions,
	NavGridView: SvgNavGridView,
	NavHelp: SvgNavHelp,
	NavHelpFill: SvgNavHelpFill,
	NavHome: SvgNavHome,
	NavHomeFill: SvgNavHomeFill,
	NavIntegrations: SvgNavIntegrations,
	NavIntegrationsFill: SvgNavIntegrationsFill,
	NavInterfaces: SvgNavInterfaces,
	NavMcp: SvgNavMcp,
	NavMenu: SvgNavMenu,
	NavMenuAlt: SvgNavMenuAlt,
	NavMoreHoriz: SvgNavMoreHoriz,
	NavMoreVert: SvgNavMoreVert,
	NavProductHub: SvgNavProductHub,
	NavProjects: SvgNavProjects,
	NavProjectsFill: SvgNavProjectsFill,
	NavSearch: SvgNavSearch,
	NavSearchFill: SvgNavSearchFill,
	NavTable: SvgNavTable,
	NavTableFill: SvgNavTableFill,
	NavTables: SvgNavTables,
	NavVersions: SvgNavVersions,
	NavVersionsFill: SvgNavVersionsFill,
	PartnerDashboard: SvgPartnerDashboard,
	PartnerEmbed: SvgPartnerEmbed,
	PersonAdd: SvgPersonAdd,
	PersonAddFill: SvgPersonAddFill,
	PersonCircle: SvgPersonCircle,
	PersonCircleFill: SvgPersonCircleFill,
	PersonGroup: SvgPersonGroup,
	PersonGroupFill: SvgPersonGroupFill,
	PersonOne: SvgPersonOne,
	PersonOneFill: SvgPersonOneFill,
	PersonSettings: SvgPersonSettings,
	RatingCool: SvgRatingCool,
	RatingHappy: SvgRatingHappy,
	RatingHappyAlt: SvgRatingHappyAlt,
	RatingHeart: SvgRatingHeart,
	RatingHeartFill: SvgRatingHeartFill,
	RatingNeutral: SvgRatingNeutral,
	RatingNeutralAlt: SvgRatingNeutralAlt,
	RatingSad: SvgRatingSad,
	RatingSadAlt: SvgRatingSadAlt,
	RatingStar: SvgRatingStar,
	RatingStarFill: SvgRatingStarFill,
	RatingThumbsBoth: SvgRatingThumbsBoth,
	RatingThumbsBothFill: SvgRatingThumbsBothFill,
	RatingThumbsDown: SvgRatingThumbsDown,
	RatingThumbsDownFill: SvgRatingThumbsDownFill,
	RatingThumbsUp: SvgRatingThumbsUp,
	RatingThumbsUpFill: SvgRatingThumbsUpFill,
	RatingVeryHappy: SvgRatingVeryHappy,
	RatingVeryHappyAlt: SvgRatingVeryHappyAlt,
	RatingVerySad: SvgRatingVerySad,
	RatingVerySadAlt: SvgRatingVerySadAlt,
	RatingWink: SvgRatingWink,
	RatingWinkAlt: SvgRatingWinkAlt,
	StatusAppApproval: SvgStatusAppApproval,
	StatusFilter: SvgStatusFilter,
	StatusFilterFill: SvgStatusFilterFill,
	StatusPaused: SvgStatusPaused,
	StatusPlaying: SvgStatusPlaying,
	StatusPlayingFill: SvgStatusPlayingFill,
	StatusStatus: SvgStatusStatus,
	StatusStatusFill: SvgStatusStatusFill,
	StatusStop: SvgStatusStop,
	StatusStopFill: SvgStatusStopFill,
	Team: SvgTeam,
	TeamFill: SvgTeamFill,
	ZapierLogo: SvgZapierLogo
}, Symbol.toStringTag, { value: 'Module' }));

export { Icons as I };
//# sourceMappingURL=index-C7NjUcZs.mjs.map
